<script lang="ts">
  import * as Card from "$lib/components/ui/card";
  import type { AuthContext } from "$src/infrastructure/accounts/AuthContext";
  import { getContext } from "svelte";
  import { ContextTokens } from "../contexts/ContextTokens";
  import GsDatatable from "./gs-datatable.svelte";
  import { t } from "svelte-i18n";
  import { fade } from "svelte/transition";
  import MainTemplate from "../main/main-template.svelte";

  let { groupStoresAccess }: AuthContext = getContext(ContextTokens.Auth);
</script>

<MainTemplate>
  <div in:fade>
    {#if $groupStoresAccess?.groupStores}
      <Card.Root class="container mx-auto max-w-screen-lg p-0">
        <Card.Header>
          <Card.Title>{$t("page.groupstores.title")}</Card.Title>
          <Card.Description>
            {$t("page.groupstores.description")}
          </Card.Description>
        </Card.Header>
        <Card.Content>
          <GsDatatable />
        </Card.Content>
      </Card.Root>
    {/if}
  </div>
</MainTemplate>
